<template>
    <div>
        <van-nav-bar
            title="用户绑定"
        />
        <van-notice-bar :scrollable="false" color="black" background="#f2f2f2">
        店铺：{{shopName}}
        </van-notice-bar>
        <van-field
            v-model="data.telephone"
            type="tel"
            maxlength="11"
            center
            clearable
            label="手机号"
            placeholder="请输入手机号"
        >
            <template #button>
                <van-button size="small" type="info" v-show="show" @click="getCode">发送验证码</van-button>
                <van-button size="small" type="info" disabled v-show="!show">重新获取({{count}})</van-button>
            </template>
        </van-field>
        <van-field v-model="data.code" type="number" clearable maxlength="6" label="验证码" placeholder="请输入验证码" />
        <div style="margin: 10px;">
            <van-button round block type="info" native-type="submit" :disabled="bindDisabled" :loading="bindLoading" @click="bind">
                绑定
            </van-button>
        </div>
    </div>
</template>

<script>
import { NavBar, Field, Button, Toast, NoticeBar } from 'vant'
import { SmsSendCodeApi , SmsVerifyCodeApi} from '@/api/sms'
import { UserBindApi } from '@/api/vip'
import { CurShopInfoApi } from '@/api/market'
// eslint-disable-next-line no-unused-vars
// import vConsole from '@/utils/vconsole'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Field.name]: Field,
        [Button.name]: Button,
        [Toast.name]: Toast,
        [NoticeBar.name]: NoticeBar
    },
    data() {
        return {
            shopId: this.$route.params.shopId,
            vipId: this.$route.params.vipId,
            shopName: '',
            data: {
                telephone: null,
                code: ''
            },
            show: true,
            count: '',
            timer: null,
            pattern: /\d{6}/,
            bindDisabled: false,
            bindLoading: false
        }
    },
    mounted() {
        console.log(this.shopId, this.vipId)
        this.data.telephone = window.localStorage.getItem('sms-telephone') == 'null' ||
        window.localStorage.getItem('sms-telephone') == 'undefined'
        ? null: window.localStorage.getItem('sms-telephone');
        this.getShopName()
        this.getUserBindStatus()
    },
    methods: {
        telephoneValid(){
            let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
            if (!reg.test(this.data.telephone)) {
                return false;
            } else {
                return true;
            }
        },
        getUserBindStatus(){    //用户是否绑定
            var that = this
            that.axios.get(UserBindApi, {params: {shop_id:that.shopId}}).then((ret) => {
                if(ret.bind_status){
                    Toast('已绑定该店铺')
                    setTimeout(() => window.wx.closeWindow(), 2000);
                }
            })
        },
        getShopName(){
            var that = this
            that.axios.get(CurShopInfoApi, {params: {shop_id:that.shopId}}).then((ret) => {
                that.shopName= ret.details.shop_name
            })
        },
        getCode(){
            if(this.telephoneValid()){
                window.localStorage.setItem('sms-telephone', this.data.telephone)
                var that = this
                // 验证码倒计时
                const TIME_COUNT = 60;
                if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                        } else {
                        this.show = true;
                        clearInterval(this.timer);
                        this.timer = null;
                        }
                    }, 1000)
                }
                //发送验证码
                that.axios.post(SmsSendCodeApi, {telephone:this.data.telephone}).then((ret) => {
                    console.log(ret)
                    if (ret.code == 200) {
                        window.localStorage.setItem('sms-sessionId', ret.sessionId);
                    } else {
                        Toast(ret.errorMessage)
                    }
                }).catch(function (error) {
                    Toast(error)
                })
            }else{
                Toast('请检查手机号')
            }
        }, 
        bind(){
            if(this.telephoneValid()&&this.data.code.length==6){
                this.bindDisabled = true
                this.bindLoading = true
                console.log(this.data, this.shopId)
                //验证验证码
                var that = this
                that.axios.post(SmsVerifyCodeApi, {sessionId:window.localStorage.getItem('sms-sessionId'), code:that.data.code}).then((ret) => {
                    console.log(ret)
                    if (ret.code == 403||ret.code==200) {
                        console.log('sms ok')
                        console.log(ret)
                        //验证成功后进行绑定
                        that.axios.post(UserBindApi, {
                            telephone:that.data.telephone,
                            shop_id: that.shopId,
                            vip_id: that.vipId>0?that.vipId:null
                        }).then((ret) =>{
                            console.log('buind return')
                            if (ret.code == 200) {
                                Toast('绑定成功')
                                window.wx.closeWindow();
                            }else{
                                Toast(ret.message)
                            }
                        })
                    } else {
                        Toast('用户绑定失败,请联系系统管理员')
                    }
                    this.bindDisabled = false
                    this.bindLoading = false
                }).catch(function (error) {
                    Toast(error)
                    this.bindDisabled = false
                    this.bindLoading = false
                })

            }else{
                Toast('请检查手机号或者验证码')
            }
        }
    }
}
</script>

<style lang="less" scoped>
</style>